import { AHText } from "arkh";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import React, { useCallback, useMemo, useState } from "react";

import { graphql, useMutation } from "react-relay";
import { useAlert } from "../../common/Alert";
import { IntegrationNewsfeedCreateScreenMutation } from "./__generated__/IntegrationNewsfeedCreateScreenMutation.graphql";
import { FormattedMessage } from "react-intl";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";

export const IntegrationNewsfeedCreateScreen = (props: {
  navigation: StoreAdminNavigationProp<"IntegrationNewsfeedCreate">;
}) => {
  const [value, setValue] = useState("");

  const providerInfo = useMemo(() => getNewsfeedInfo(value), [value]);

  const [create, loading] =
    useMutation<IntegrationNewsfeedCreateScreenMutation>(graphql`
      mutation IntegrationNewsfeedCreateScreenMutation(
        $provider: IntegrationNewsfeedProvider!
        $info: String!
      ) {
        store {
          createIntegrationNewsfeed(provider: $provider, info: $info) {
            id
          }
        }
      }
    `);

  const Alert = useAlert();
  const onCreate = useCallback(() => {
    create({
      onError: () => {
        Alert.alert(
          "Fel Uppstod",
          "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt länk "
        );
      },
      onCompleted: (d) => {
        if (d.store.createIntegrationNewsfeed?.id) {
          props.navigation.goBack();
        } else {
          Alert.error(
            "Fel Uppstod",
            "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt länk "
          );
        }
      },
      variables: { provider: providerInfo!.provider, info: providerInfo!.info },
    });
  }, [create, providerInfo, Alert, props.navigation]);

  return (
    <IntegrationActivateScreen
      header={
        <IntegrationActivateScreen.Header
          logo={
            <AHText type="title">
              <FormattedMessage
                description="IntegrationsAdminNewsfeed create screen title"
                defaultMessage="Newsfeed"
              />
            </AHText>
          }
        />
      }
      activation={
        <IntegrationActivateScreen.Input
          value={value}
          onChangeText={setValue}
          type="url"
          label={
            <FormattedMessage
              description="IntegrationsAdminNewsfeed create screen instruction"
              defaultMessage="Paste a link to your newsfeed here"
            />
          }
        />
      }
      onActivate={onCreate}
      isValid={!!providerInfo}
      isActivating={loading}
    />
  );
};

export function getNewsfeedInfo(
  input: string
): undefined | { provider: "FALCON"; info: string } {
  try {
    let url = new URL(input);

    if (url.hostname === "app.falcon.io") {
      url = new URL(`${url.protocol}//./${url.hash.substring(1)}`);
      const token = url.searchParams.get("token") ?? "";
      const pathSegments = url.pathname.split("/");
      let id = pathSegments[pathSegments.length - 1] ?? "";
      if (id.length === 0) id = pathSegments[pathSegments.length - 2] ?? ";";

      if (token.length !== 0 && id.length !== 0) {
        return {
          provider: "FALCON" as const,
          info: `${id}|${token}`,
        };
      }
    }
  } catch {}
}
